import { Button } from '@dd3tech/wiggui/Button'
import { Modal } from '@dd3tech/wiggui/Modal'
import { Text } from '@dd3tech/wiggui/Text'
import { PropertyUnavailableSvg } from '../../svg'
import { useModalUnavailableStore } from '../../store/modals/modal-unavailable-store'

export const ModalUnavailableProperty = () => {
  const isOpen = useModalUnavailableStore((state) => state.isOpen)
  const setIsOpen = useModalUnavailableStore((state) => state.setIsOpen)
  return (
    <Modal
      enableBgBlur
      className="w-full max-w-[612px]"
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <Modal.Body className="flex flex-col items-center justify-center gap-6 px-6">
        <PropertyUnavailableSvg />
        <Text className="text-primary text-body-bold-xl">
          Esta propiedad ya no está disponible
        </Text>
      </Modal.Body>
      <Modal.Footer className="px-6 py-3 w-full border-t border-surface-strokes flex items-center justify-center">
        <Button variant="secondary" onClick={() => setIsOpen(false)}>
          Entendido
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
